import React, { useCallback, useState } from 'react'

import { BrokerSignSMSCodeForm } from '../../shared/broker/sms-form'
import { BrokerSignSuccess } from '../../shared/broker/success'
import { BrokerSignScreenBaseProps } from '../../shared/broker/types'

import { BrokerSignAgreementConsent } from './agreement-consent'

export const BrokerConsentScreen = (props: BrokerSignScreenBaseProps) => {
	const [step, setStep] = useState(0)
	const handleNext = useCallback(() => setStep((step) => step + 1), [])

	if (step === 0) {
		return React.createElement(BrokerSignAgreementConsent, {
			...props,
			onNext: handleNext,
		})
	}

	if (step === 1) {
		return React.createElement(BrokerSignSMSCodeForm, {
			...props,
			title: 'Подтвердите регистрацию',
			onNext: handleNext,
		})
	}

	return React.createElement(BrokerSignSuccess, {
		content: 'Скоро с вами свяжется ваш менеджер, чтобы продолжить работу над вашей заявкой.',
	})
}
